import React, { Fragment } from 'react';

import { ArrowCircleLeftIcon, ArrowCircleRightIcon } from 'zoomforth_component_lib/external_modern_icons.jsx';

export default ({ shouldShowNext, shouldShowPrev, onNext, onPrev }) => (
  <Fragment>
    {
      shouldShowNext &&
      <div onClick={onNext} className="galleria-arrow galleria-image-nav-right">
        <ArrowCircleRightIcon />
      </div>
    }

    {
      shouldShowPrev &&
      <div onClick={onPrev} className="galleria-arrow galleria-image-nav-left">
        <ArrowCircleLeftIcon />
      </div>
    }
  </Fragment>
);
